// extracted by mini-css-extract-plugin
module.exports = {"HeaderContainer":"Header_HeaderContainer__163sn","wrapper":"Header_wrapper__3vOcl","Logo":"Header_Logo__2sn6y"};